export default "__VITE_ASSET__BsI2qPF3__"